import PPMLogo from '@propertypal/shared/src/resources/logos/ppm-logo.svg';
import styled from 'styled-components';

const PPMLogoMedium = styled(PPMLogo).withConfig({
  shouldForwardProp: () => false,
})`
  ${(props) => (props.maxSize ? `max-width:${props.maxSize}px` : `max-width: 205px`)};
  ${(props) => (props.mb ? `margin-bottom:${props.mb}px;` : ``)}
  ${(props) => (props.verticalAlign ? `vertical-align: ${props.verticalAlign};` : ``)}
`;

export default PPMLogoMedium;
